// extracted by mini-css-extract-plugin
export default {"wrapper":"HeroCard_wrapper__JBxkM","media":"HeroCard_media__0-7Vp","content":"HeroCard_content__1ZPkf"};